<template>
  <div class="wg-row" style="height:100%;">
    <!-- Room modal -->
    <wg-modal
      :width="'400px'"
      v-if="showRoomModal"
      @closeModal="showRoomModal = false;"
    >
      <div slot="header">
        <div class="com-anm22-app-text-xl" style="font-weight:bold;">
          {{ Number.isInteger(selected.id) 
              ? $anm22.strLang(lang, 'Edit room', 'Modifica sala')
              : $anm22.strLang(lang, 'Add room', 'Aggiungi sala') }}
        </div>
      </div>
      <div slot="body" class="wg-row">
        <div class="wg-row">
          <div class="com-anm22-app-text-xl" style="font-weight:bold;">
            {{ $anm22.strLang(lang, 'Name', 'Nome') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              type="text"
              v-model="selected.name">   
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Save', 'Salva')" 
              @click="saveRoom">
        </div>
        <template v-if="selected.id">
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <input 
                type="button"
                class="com-anm22-button-red" 
                :value="$anm22.strLang(lang, 'Delete', 'Elimina')" 
                @click="deleteRoom">
          </div>
        </template>
      </div>
    </wg-modal>
    <!-- Table modal -->
    <wg-modal
      :width="'400px'"
      v-if="showTableModal"
      @closeModal="showTableModal = false;"
    >
      <div slot="header">
        <div class="com-anm22-app-text-xl" style="font-weight:bold;">
          {{ selected.id
              ? $anm22.strLang(lang, 'Edit table', 'Modifica tavolo')
              : $anm22.strLang(lang, 'Add table', 'Aggiungi tavolo') }}
        </div>
      </div>
      <div slot="body" class="wg-row">
        <div class="wg-row">
          <div class="com-anm22-app-text-xl" style="font-weight:bold;">
            {{ $anm22.strLang(lang, 'Name', 'Nome') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              type="text"
              v-model="selected.name">   
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl" style="font-weight:bold;">
            {{ $anm22.strLang(lang, 'Column', 'Colonna') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              type="text"
              :value="selected.posX + 1"
              @input="selected.posX = $event.target.value - 1">   
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl" style="font-weight:bold;">
            {{ $anm22.strLang(lang, 'Row', 'Riga') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <input 
              type="text"
              :value="selected.posY + 1"
              @input="selected.posY = $event.target.value - 1">
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <div class="com-anm22-app-text-xl" style="font-weight:bold;">
            {{ $anm22.strLang(lang, 'Room', 'Sala') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <select class="com-anm22-app-select" v-model="selected.room">
            <option 
              v-for="(room,i) in rooms"
              :key="'table-room-'+i"
              :value="room.id"
            >
              {{ room.name }}
            </option>
          </select>  
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Save', 'Salva')" 
              @click="saveTable">
        </div>
        <template v-if="selected.id">
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <input 
                type="button" 
                class="com-anm22-button-red"
                :value="$anm22.strLang(lang, 'Delete', 'Elimina')" 
                @click="deleteTable">
          </div>
        </template>
      </div>
    </wg-modal>
    <!-- Page -->
    <div style="font-size:24px;margin:10px 0;">
      {{ $anm22.strLang(lang, 'Tables map editor', 'Editor mappa tavoli') }}
    </div>
    <div class="wg-row">
      <div class="display-flex" style="flex-wrap:nowrap;align-items:center;cursor:pointer;" @click="addRoom">
        <img 
            :src="$anm22.icons.getWorldIcon('addGreen')"
            class="com-anm22-app-img-fixed-height-m">
        <div class="com-anm22-app-text-l" style="margin-left:10px;">
          {{ $anm22.strLang(lang, 'Add room', 'Aggiungi sala') }}
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <template v-if="rooms.length > 0">
      <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
        <div class="com-anm22-app-text-xl" style="margin-right:10px;">
          {{ $anm22.strLang(lang, 'Room', 'Sala') }}
        </div>
        <select v-if="rooms.length > 1" class="com-anm22-app-select" v-model="roomId">
          <option 
            v-for="(room,i) in rooms"
            :key="'select-room-'+i"
            :value="room.id"
          >
            {{ room.name }}
          </option>
        </select>
        <div v-else class="com-anm22-app-text-xl">{{ rooms.find(r => r.id === roomId).name }}</div>
        <img 
            :src="$anm22.icons.getWorldIcon('menuSettings')"
            class="com-anm22-app-img-fixed-height-m"
            style="margin-left:10px;cursor:pointer;"
            @click="edit(rooms.find(r => r.id === roomId), 'room')" >
        <div class="display-flex" style="flex-wrap:nowrap;align-items:center;cursor:pointer;margin-left:auto;" @click="addTable">
          <img 
              :src="$anm22.icons.getWorldIcon('addGreen')"
              class="com-anm22-app-img-fixed-height-m" >
          <div class="com-anm22-app-text-l" style="margin-left:10px;">
            {{ $anm22.strLang(lang, 'Add table', 'Aggiungi tavolo') }}
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div
          class="wg-row com-anm22-food-tables-map-edit com-anm22-food-scrolling-panel"
          :style="{height: mapHeight + 'px'}"
      >
        <div
            v-for="(t,index) in tables.filter(t => t.room == roomId)"
            :key="'table-'+index"
            class="com-anm22-food-table-map-setting-el"
            :style="{top: (4+44*t.posY)+'px', left:(4+104*t.posX)+'px'}"
            @click="edit(t, 'table')"
        >
          <div class="wg-row" style="height:100%;padding:5px;flex-wrap:nowrap;align-items:center;justify-content:center;">
            <div class="com-anm22-app-text-l">
              {{ t.name }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {},
  data() {
    return {
      loading: true,
      // Page
      roomId: null,
      // Edit
      selected: null,
      showRoomModal: false,
      showTableModal: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      selectedLicense: state => state.licenseSelected,
      windowHeight: state => state.windowHeight,
      deviceSpecs: state =>  state.deviceSpecs
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.selectedLicense);
    },
    employment() {
      return this.$store.getters["foodEmployments/get"](
        this.license.id + "-" + this.user.idWorldUser
      );
    },
    permission() {
      return this.employment ? this.employment.permission : 6;
    },
    rooms() {
      return this.$store.getters['foodRooms/getByLicense'](this.license.id).filter(r => !r.deleted);
    },
    tables() {
      return this.$store.getters['foodTables/getByLicense'](this.license.id).filter(t => !t.deleted);
    },
    mapHeight() {
      const isAndroid = this.deviceSpecs.mobile === 'a' && this.deviceSpecs.browser === 'gc';
      const isIphone = this.deviceSpecs.mobile === 'i' && this.deviceSpecs.browser === 'sa';
      if(isAndroid || isIphone) {
        return this.windowHeight - 263;
      } else {
        return this.windowHeight - 60;
      }
    }
  },
  methods: {
    edit(elem, type) {
      this.selected = elem;
      if(type === 'room') {
        this.showRoomModal = true;
      } else {
        this.showTableModal = true;
      }
    },
    addRoom() {
      const localId = this.$anm22.genLocalId();
      this.edit({
        id: localId,
        dbKey: localId,
        name: '',
        license: this.license.id
      }, 'room');
    },
    async saveRoom() {
      let roomId = null;
      const mode = Number.isInteger(this.selected.id) ? 'edit' : 'new';
      try {
        const response = await this.$http.post('settings/save-room', {
          room: this.selected
        });
        await this.$store.dispatch('foodRooms/update', {
          vlf: this.$vlf('foodRooms'), objs: response.data.rooms
        });
        roomId = response.data.rooms[0].id;
      } catch (e) {
        await Promise.all([
          this.$store.dispatch('foodRooms/update', {
            vlf: this.$vlf('foodRooms'), objs: [ this.selected ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodRoom",
            _table: "foodRooms",
            mode: mode,
            type: 'obj',
            obj: this.selected
          })
        ]);
        roomId = this.selected.id;
      } finally {
        this.showRoomModal = false;
        this.selected = null;
        if(mode === 'new') {
          this.$nextTick(() => {
            this.roomId = roomId;
          });
        }
      }
    },
    async deleteRoom() {
      try {
        // Check if room is local only (not synced)
        if(!Number.isInteger(this.selected.id)) {
          throw new Error('Local object');
        }
        const response = await this.$http.post('settings/delete-room', {
          roomId: this.selected.id
        });
        if(response.data.success) {
          this.selected.deleted = true;
          await this.$store.dispatch('foodRooms/update', {
            vlf: this.$vlf('foodRooms'), obj: this.selected
          });
        } else {}
      } catch(e) {
        // setto come cancellati i tavoli di questa stanza
        const tables = this.$store.getters['foodTables/getByRoom'](this.selected.id);
        tables.forEach(table => {
          table.deleted = true;
          this.$store.dispatch('foodTables/update', {
            vlf: this.$vlf('foodTables'), obj: table
          }),
          this.store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: 'FoodTable',
            _table: 'foodTables',
            mode: 'edit',
            type: 'obj',
            obj: table
          })
        });
        this.selected.deleted = true;
        await Promise.all([
          this.$store.dispatch('foodRooms/update', {
            vlf: this.$vlf('foodRooms'), obj: this.selected
          }),
          this.store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: 'FoodRoom',
            _table: 'foodRooms',
            mode: 'delete',
            type: 'obj',
            obj: this.selected
          })
        ]);
      } finally {
        if(this.roomId === this.selected.id) {
          this.$nextTick(() => {
            if(this.rooms.length > 0) {
              this.roomId = this.rooms[0].id;
            } else {
              this.roomId = null;
            }
          });
        }
        this.showRoomModal = false;
        this.selected = null;
      }
    },
    addTable() {
      const localId = this.$anm22.genLocalId();
      this.edit({
        id: localId,
        dbKey: localId,
        name: '',
        posX: 0,
        posY: 0,
        room: this.roomId,
        license: this.license.id,
        isOccupied: false
      }, 'table');
    },
    async saveTable() {
      const mode = Number.isInteger(this.selected.id) ? 'edit' : 'new';
      try {
        if(!Number.isInteger(this.selected.room)){
          throw new Error('Object not synced');
        }
        const response = await this.$http.post('settings/save-table', {
          table: this.selected
        });
        await this.$store.dispatch('foodTables/update', {
          vlf: this.$vlf('foodTables'), objs: response.data.tables
        });
      } catch(e) {
        await Promise.all([
          this.$store.dispatch('foodTables/update', {
            vlf: this.$vlf('foodTables'), objs: [ this.selected ]
          }),
          this.$store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: "FoodTable",
            _table: "foodTables",
            mode: mode,
            type: 'obj',
            obj: this.selected
          })
        ]);
      } finally {
        this.showTableModal = false;
        this.selected = null;
      }
    },
    async deleteTable() {
      try {
        const response = await this.$http.post('settings/delete-table', {
          tableId: this.selected.id
        });
        if(response.data.success) {
          this.selected.deleted = true;
          await this.$store.dispatch('foodTables/update', {
            vlf: this.$vlf('foodTables'), obj: this.selected
          });
        } else {}
      } catch(e) {
        this.selected.deleted = true;
        await Promise.all([
          this.$store.dispatch('foodTables/update', {
            vlf: this.$vlf('foodTables'), obj: this.selected
          }),
          this.store.dispatch('offline/saveSyncTuple', {
            _vue: this,
            _class: 'FoodTable',
            _table: 'foodTables',
            mode: 'edit',
            type: 'obj',
            obj: this.selected
          })
        ]);
      } finally {
        this.showTableModal = false;
        this.selected = null;
      }
    },
    async loadData() {
      Promise.all([
        this.$store.dispatch('foodRooms/load', this.$vlf('foodRooms')),
        this.$store.dispatch('foodTables/load', this.$vlf('fooTables')),
      ]);
    },
  },
  async created() {
    // Blocco l'accesso se ho un permesso di basso livello o se la licenza è una delle demo e il permesso non è superuser
    if(this.permission > 3 
        || (this.permission !== 1 && (this.license.work === 1 || this.license.work === 2 || this.license.work === 289))) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    if(!this.license.config.modules.tables.enabled) {
      this.$router.push('/').catch(e => console.log(e));
      return;
    }
    this.loading = true;
    try {
      const response = await this.$http.get('settings/tables');
      await Promise.all([
        this.$store.dispatch('foodRooms/update', {
          vlf: this.$vlf('foodRooms'), objs: response.data.rooms, cleanFilters: []
        }),
        this.$store.dispatch('foodTables/update', {
          vlf: this.$vlf('foodTables'), objs: response.data.tables, cleanFilters: []
        }),
      ]);
    } catch (e) {
      await this.loadData();
    } finally {
      this.loading = false;
      this.roomId = this.rooms.length > 0 ? this.rooms[0].id : null;
    }
  },
}
</script>

<style lang="scss" scoped>
.room-button {
  height: 40px;
  box-shadow: 0 0 0 2px #ddd;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 0 5px;
  cursor: pointer;
  font-size: 16px;
  flex-wrap: nowrap;
  align-items:center;
  &.selected {
    color: white;
    background-color: #90A4AE;
  }
}
</style>
